<template>
    <div id="vetroConn">
        <b-input-group size="md" prepend="Token">
            <b-input type="token" v-model="connection.token" autocomplete="false" :disabled="isReadonly"></b-input>
        </b-input-group>
    </div>
</template>

<script>
// components

// server

// modules

export default {
  name: "vetro-conn",

  props: {
    isReadonly: Boolean,
    connection: Object,
  },

  data() {
    return {
    };
  },

  computed: {

  },

  methods: {

    // UI Events

    // other

    reset() {
      
    },

    prepareForSave() {
      
    },

  }
};
</script>


<style scoped lange="css">

</style>


// WEBPACK FOOTER //
// src/components/connection/VetroConnection.vue